export const API_ERROR = "api_failed";
export const CLEAR_DATA = "mR_Clear_data";

export const INPUT_CHANGEVALUE = "input_ChangeValue";
export const SELECT_CHANGEVALUE = "Select_ChangeValue";
export const MR_INPUT_CHANGEVALUE = "mr_input_ChangeValue";
export const MR_SELECT_CHANGEVALUE = "mr_Select_ChangeValue";
export const SI_INPUT_CHANGEVALUE = "SI_input_ChangeValue";
export const ITEM_QTY_CHANGEVALUE = "mr_item_Qty-changeValue";
export const ITEM_UNITES_CHANGEVALUE = "Item_units_changeValue";
export const SI_SELECT_CHANGEVALUE = "SI_Select_ChangeValue";
export const PRODUCTS_REQUEST_LIST = "mr_products_request_list";
export const PRODUCTS_REQUEST_LIST_SUCCESS = "mr_products_request_list_success";
export const PRODUCTS_ROW_REQUEST = "products_Row_request";
export const PRODUCTS_ROW_REQUEST_SUCCESS = "products_Row_request_success";
export const SELECTED_PRODUCTS_LIST = "selected_products_list";
export const REMOVE_SELECTED_PRODUCT = "remove_selected_product";
export const MATERIALREQUEST_ADD = "materialrequest_add";
export const MATERIALREQUEST_ADD_SUCCESS = "materialrequest_add_success";
export const MY_MATERIALREQUEST_LIST = "My_materialrequest_List";

export const MATERIALREQUEST_LIST = "materialrequest_List";
export const DEPT_MATERIALREQUEST_LIST = "Dept_materialrequest_List";
export const ALL_MATERIALREQUEST_LIST = "all_materialrequest_List";
export const MATERIALREQUEST_LIST_COUNT = "materialrequest_List_Count";
export const MY_MATERIALREQUEST_LIST_COUNT = "my_materialrequest_List_Count";
export const DEPT_MATERIALREQUEST_LIST_COUNT =
  "dept_materialrequest_List_Count";
export const ALL_MATERIALREQUEST_LIST_COUNT = "all_materialrequest_List_Count";

export const MATERIALREQUEST_LIST_COUNT_SUCCESS =
  "materialrequest_list_Count_success";
export const MATERIALREQUEST_LIST_SUCCESS = "materialrequest_list_success";

export const GET_USER_DEPARTMENT = "materialrequest_get_User_Department";
export const USER_DEPARTMENT_SUCCESS =
  "materialrequest_get_User_Department_success";
export const MATERIALREQUEST_ROW_DATA = "materialrequest_Row_Data";
export const MATERIALREQUEST_ROW_DATA_SUCCESS = "materialrequest_Row_success";

export const TOGGLE_ITEM_MENU = "materialrequest_toggle_item_Menu";

export const MATERIALREQUEST_DELETE = "materialrequest_delete";
export const ITEM_HOD_APPROVAL = "itemHodApproval";
export const MR_DEPT_HOD_APPROVE_ADD = "mr_dept_hod_approve_add";

export const ALL_MR_HOD_ITEM_LIST_CHECKED = "All_mr_hod_items_list_Checked";
export const MR_HOD_ITEM_LIST_CHECKED = "mr_hod_items_list_Checked";
export const MR_ITEM_HOD_APPROVAL = "MritemHodApproval";
export const MRI_STORE_USER_APPROVAL = "Mr_MRISUserApproval";
export const MRI_STORE_HOD_APPROVAL = "Mr_MRISHodApproval";
export const MR_HOD_APPROVE_ADD = "mr_hod_approve_add";
export const MODEL_OPEN = "mr_addItem_model_open";
export const MODEL_CLOSE = "mr_addItem_model_close";
export const MODEL_LIST_OPEN = "MR_listItem_model_open";
export const MODEL_LIST_CLOSE = "listItem_model_close";
export const MT_ROW_LOADING = "mr_Row_loading";
export const C_PRODUCT_IMAGE = "c_product_image";
export const C_PRODUCT_CHANGEVALUE = "c_product_ChangeValue";
export const C_PRODUCT_SELECT_CHANGEVALUE = "c_product_Select_ChangeValue";
export const CUSTOM_PRODUCT_ADD = "custom_product_add";
export const CUSTOMPRODUCT_ADD_SUCCESS = "customproduct_add_success";
export const CHANGE_TOGGALE_TAB = "change_toggale_tab";
export const SET_PARAMS = "mi_set_params";
export const FILTER_INPUT_CHANGEVALUE = "mi_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "mi_Filter_Select_ChangeValue";
export const LIST_LAYOUT = "mi_list_layout";

export const CHANGE_ITEM_MODEL_OPEN = "mr_dept_change_item_model_open";
export const CHANGE_ITEM_MODEL_CLOSE = "mr_dept_change_item_model_close";

// C_PRODUCT_RIGHT_SIDEBAR
export const C_PRODUCT_RIGHT_SIDEBAR = "C_PRODUCT_RIGHT_SIDEBAR";
export const C_PRODUCT_HIDE_RIGHT_SIDEBAR = "C_PRODUCT_HIDE_RIGHT_SIDEBAR";
export const CHANGE_ACTIVATE_PRODUCT = "CHANGE_ACTIVATE_PRODUCT";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "mr_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "mr_filter_hide_right_sidebar";
export const CLEAR_FILTER = "mr_clear_filter";

export const VIEW_LOG_SHOW_RIGHT_SIDEBAR = "mr_viewLog_show_right_sidebar";
export const VIEW_LOG_HIDE_RIGHT_SIDEBAR = "mr_viewLog_hide_right_sidebar";

export const ITEM_TIME_LINE = "mr_item_time_line";
export const ITEM_TIME_LINE_SUCCESSFUL = "mr_item_time_line_successful";
export const PI_ITEM_TIME_LINE = "mr_PI_item_time_line";
export const PO_ITEM_TIME_LINE = "mr_PO_item_time_line";
export const IGP_ITEM_TIME_LINE = "mr_IGP_item_time_line ";

export const PRODUCT_STORE_QTY = "MR_getProductStoreQty";
export const PRODUCT_STORE_QTY_SUCCESSFUL = "MR_getProductStoreQtySuccessful";

export const PDF_DOWNNLOAD = "MR_PDF_Download";

export const PRODUCT_HISTORY = "MR_product_history";
export const PRODUCT_HISTORY_SUCCESSFUL = "MR_product_history_successful";
export const PRODUCT_HISTORY_MODEL_CLOSE = "MR_product_history_model_close";

export const MR_ITEM_IMAGES_UPLOAD = "MR_item_images_upload";

export const MR_ITEM_UPDATE_IMAGE = "MR_item_update_images";

export const PRODUCT_ITEM_HISTORY_MODEL_OPEN =
  "MR_product_Item_history_modelOpen";
export const PRODUCT_ITEM_HISTORY_MODEL_CLOSE =
  "MR_product_Item_history_modelClose";

export const MATERIAL_REQUEST_CLOSE = "material_request_close";

export const MRQ_FOCUS_POST = "mrqFocusPost";
